import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { RiskForApproval } from '../../model/riskDashboard';

import { RiskService } from './../../services/risk.service';

@Component({
  selector: 'ara-risk-pending-approval',
  templateUrl: './risk-pending-approval.component.html',
  styleUrls: ['./risk-pending-approval.component.css']
})
export class RiskPendingApprovalComponent implements OnInit {

  @ViewChild('cm') contextMenu: ContextMenu;
  riskData: RiskForApproval[] = [];
  noRecordsMsg: string;
  loggedInUserJSON: any;

  constructor(private baseService: BaseService,
    private riskService: RiskService,
    private commonService: CommonService,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
    ) 
    {
    
  }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    

    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
    
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    this.getRiskForApproval();
  }
   
  getRiskForApproval() {
    this.baseService.showRootLoader = true;
    
    const apiRequest = {
      Model:
      {
        UserId: this.loggedInUserJSON.UserId

      } 
    };
    this.riskService.getRiskForApproval(apiRequest, this.callbackMethodForgetRiskForApproval.bind(this));
  }
  callbackMethodForgetRiskForApproval(response) {
    if (response && response.Success && response.Result.length > 0) 
    {
    this.riskData = response.Result;
      
    }
   
      else 
      {
        this.noRecordsMsg = 'No records found!';
      }
    
     
    //this.getRiskData();
    this.baseService.showRootLoader = false;
  }
    
 
     
  highlightCurrentSelectedRisk(id) {
    var el = document.getElementById(id);
    while ( el !== null) {    
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== 'darkgray') {
        document.getElementById(id).style.backgroundColor = 'darkgray';
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.riskService.setcurrentRiskRequestId(id);
  }
  ngAfterViewChecked() {
    let currentRiskRequestId = this.riskService.getcurrentRiskRequestId();
    if (currentRiskRequestId !== '') {
      this.highlightCurrentSelectedRisk(currentRiskRequestId);
    }
  }
  
   
   
    
 

} 